export interface IButtonAnswer {
    label: string;
}

export class ButtonAnswer implements IButtonAnswer {
    label: string;
    constructor(label: string) {
        this.label = label;
    }
}
